/**
*
* StudentReports
*
*/

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// import s tyled from 'styled-components';

import { FormattedMessage } from 'react-intl';
import { useApi2 } from 'containers/Api2/index.js';
import { Alert, ListGroup, ListGroupItem, Card } from 'react-bootstrap';
import Spinner from 'components/Spinner/index.jsx';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import useDateFormats from 'containers/LanguageProvider/useDateFormats.js';
import messages from './messages.js';

function StudentReports(props) {
  const { studentId } = props;
  const learningprogress = useApi2({ url: `students/${studentId}/learningprogress`, noReport: [401] });
  const { dateTimeFormat } = useDateFormats();

  function renderBody() {
    if (learningprogress.sections.length === 0) {
      return <Alert variant="info"><FormattedMessage {...messages.noReports} /></Alert>;
    }
    return learningprogress.sections.map((section) => (
      <Fragment key={section.title}>
        <h3>{section.title}</h3>
        <ListGroup>
          {section.documents.map((doc) => (
            <ListGroupItem key={doc.url}>
              <a href={doc.url} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                <AvatarWithText icon="ss-file-pdf-o">
                  <div className="font-monospace">{doc.name}</div>
                  <div className="text-gray small">{dateTimeFormat.format(doc.modified)}</div>
                </AvatarWithText>
              </a>
            </ListGroupItem>
          ))}
        </ListGroup>
      </Fragment>
    ));
  }

  if (learningprogress.loading) {
    return <Spinner />;
  }

  if (!learningprogress.sections) {
    return null;
  }

  return (
    <Card>
      <Card.Body>
        <Card.Title as="h2" className="mb-4"><FormattedMessage {...messages.header} /></Card.Title>
        {renderBody()}
      </Card.Body>
    </Card>
  );
}

StudentReports.propTypes = {
  studentId: PropTypes.number,
};

export default (StudentReports);
